import React, { useState } from 'react'
import AnimateHeight from 'react-animate-height'

import { onEnter } from '../../../utilities/accessibility/onEnter'
import '../../../styles/scss/filters/expandable-filters.scss'

const ExpandableFilters = ({ children }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <div className="u-flex u-flex-column expandable-filters">
      <div
        className={`u-flex expandable-filters__toggle-button ${expanded ? 'expandable-filters__toggle-expanded' : ''}`}
        aria-label="Filters"
        onClick={() => setExpanded(!expanded)}
        onKeyDown={event => onEnter(event, () => setExpanded(!expanded))}
        role="button"
        tabIndex="0"
      >
        Filters
      </div>
      <AnimateHeight
        contentClassName="expandable-filters__content-container"
        height={expanded ? 'auto' : 0}
      >
        {children}
      </AnimateHeight>
    </div>
  )
}

export default ExpandableFilters
